<template>
  <div>
    <Modal v-model="isShow" @on-ok="ok" :loading="loading" :mask-closable="false">
      <h3 slot="header" class="modal-header">活动配置</h3>
      <Row class="row" >
        <Col span="6">活动名称</Col>
        <Col span="6">服务费折扣值</Col>
        <Col span="6">活动编码(与友家活动一致填写)</Col>
        <Col span="2">是否推送大搜索</Col>

        <Col span="4">操作</Col>
      </Row>
      <Row class="row" v-for="(item,index) in data " :key="item.fid">
        <Col span="6">
          <Input class="width150" :maxlength="50" v-model="item.labelName"/>
        </Col>
        <Col span="6">
          <Input class="width150" :maxlength="50" v-model="item.labelCode"/>%
        </Col>
        <Col span="6">
          <Input class="width150" :maxlength="50" v-model="item.remark"/>
        </Col>

        <Col span="2">
          <Select v-model="item.pushSearch">
            <Option value="0">否</Option>
            <Option value="1">是</Option>
          </Select>
        </Col>

        <Col span="4">
          <a @click.stop="deleteItem(item,index)">删除</a>
        </Col>
      </Row>
      <div class="mt20">
        <a @click.stop="addItem">+ 添加</a>
      </div>
    </Modal>
  </div>

</template>

<script>
  import {labellist,labelremove,labeledit} from "api/projectConfig";

  export default {
    name: "ActivityList",
    components:{
    },
    props:{
      n: {
        type: Number,
        default: 0
      },
      houseTypeFid:{
        type:String,
        default:''
      }
    },
    watch:{
      n(){
        this.getLabellist()
        this.isShow=true
      },
    },
    data(){
      return {
        isShow:false,
        data:[],
        loading:true
      }
    },
    methods:{
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      addItem(){
        this.data.push({
          "fid": "",
          "labelName": "",
          "labelCode": "",
          "remark":"",
          "push_search":"",
          "moduleId": this.houseTypeFid,
          "labelType":3
        })
      },
      getLabellist(){
        if(!this.houseTypeFid){
          return
        }
        var params={
          moduleFid:this.houseTypeFid,
          type:3
        }
          labellist(params).then(res=>{
          this.data=res.data
        })

      },
      deleteItem(item,index){

        this.$Modal.confirm({
          content: '<p>确认删除？</p>',
          onOk: () => {
            if(item.fid){
              let params={
                fid:item.fid
              }
                labelremove(params).then(res=>{
                this.$Message.success('删除成功')
                this.getLabellist()
              })
            }
            else {
              this.data.splice(index,1)
            }
          }
        })
      },
      ok(){
        var isNull=false
        var isNum=true;

        this.data.forEach(ele=>{
          if( ele.labelName==''||ele.labelCode==''){
            isNull=true
            return
          }
          var numReg = /^[0-9]+$/;
          var numRe = new RegExp(numReg);
          if(!numRe.test(ele.labelCode)){
             isNum=false;
             return;
          }
        })
        if(!isNum){
          this.$Message.info('输入整数！')
          this.changeLoading()
          return
        }
        if(isNull){
          this.$Message.info('名称，code不能为空！')
          this.changeLoading()
          return
        }
        var params={
          moduleFid:this.houseTypeFid,
          labelEntities:this.data,
          proHouseTypeFid:this.houseTypeFid,
          type:2
        }
          labeledit(params).then(res=>{
          this.changeLoading()
          this.$Message.success('保存成功')
          this.show = false
        }).catch(err=>{}).finally(()=>{
            this.changeLoading()
          })
      },

    },
    created(){
    }
  }
</script>

<style scoped>
  .width150{
    width: 100px;
  }
  .width80{
    width: 50px;
  }
  .row {
    text-align: center;
    /*margin-bottom: 10px;*/
    line-height: 32px;

    border-left: 1px solid rgb(222, 222, 222);
    border-right: 1px solid rgb(222, 222, 222);
    border-bottom: 1px solid rgb(222, 222, 222);
    padding: 7px;
  }

  .row:first-child {
    border-top: 1px solid rgb(222, 222, 222);
    background-color: rgb(248, 248, 248);
    padding: 5px;
  }

</style>
